<template>
  <div class="modal-wraper"
       :class="modalClass"
       v-if="visible">
    <div class="modal-mask"
         @click="fnCloseModal"
         v-if="mask"></div>
    <div :id="id"
         class="modal"
         :style="style ? style : ''">
      <a href="javascript:;"
         class="close"
         @click="fnCloseModal"
         v-if="hasClose">
        <svg xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink"
             width="14px"
             height="14px">
          <path fill-rule="evenodd"
                fill="rgb(136, 136, 136)"
                d="M8.414,6.999 L13.364,11.949 C13.754,12.340 13.754,12.973 13.364,13.363 C12.973,13.754 12.340,13.754 11.949,13.363 L7.000,8.414 L2.050,13.363 C1.660,13.754 1.026,13.754 0.636,13.363 C0.245,12.973 0.245,12.340 0.636,11.949 L5.586,6.999 L0.636,2.049 C0.245,1.659 0.245,1.026 0.636,0.635 C1.026,0.245 1.660,0.245 2.050,0.635 L7.000,5.585 L11.949,0.635 C12.340,0.245 12.973,0.245 13.364,0.635 C13.754,1.026 13.754,1.659 13.364,2.049 L8.414,6.999 Z" />
        </svg>
      </a>
      <div :id="idTitle"
           class="title"
           v-if="title"
           v-html="title"></div>
      <div class="content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalSlot',
  props: {
    data: Object,
    idlist: Number
  },
  data () {
    return {
      title: null,
      hasClose: true,
      mask: false,
      modalClass: null,
      style: null,
      visible: true,
      dateInfo: Date.now(),
      id: null,
      idTitle: null,
      dragTimer: 0
    }
  },
  watch: {
    data (a, b) {
      this.fnInitModal()
    }
  },
  mounted () {
    this.fnInitModal()
    this.$nextTick(() => {
      this.bind()
    })
  },
  methods: {
    fnInitModal () {
      this.$store.commit('FNMODAL', {
        num: this.$store.state.wndModal.num + 1,
        zIndex: this.$store.state.wndModal.zIndex + 1
      })
      this.title = this.data.title || ''
      this.modalClass = this.data.class || ''
      this.style = this.data.style
      this.style.zIndex = this.$store.state.wndModal.zIndex
      this.id = 'modal' + this.dateInfo
      this.idTitle = 'title' + this.dateInfo
      this.visible = this.data.visible ? this.data.visible : true
    },
    fnCloseModal () {
      this.$emit('fnBtnClick', {
        dataType: 'modalSlotClose',
        dataClose: this.data.type,
        id: this.idlist
      })
      this.$store.commit('FNMODAL', {
        num: this.$store.state.wndModal.num - 1,
        zIndex: this.$store.state.wndModal.zIndex - 1
      })
      this.visible = false
    },
    bind () {
      const dialogHeaderEl = document.getElementById(this.idTitle)
      const dragDom = document.getElementById(this.id)
      dialogHeaderEl.style.cssText += ';cursor:move;'
      // dragDom.style.cssText += ';top:0px;'

      // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
      const getStyle = (function () {
        if (window.document.currentStyle) {
          return (dom, attr) => dom.currentStyle[attr]
        } else {
          return (dom, attr) => getComputedStyle(dom, false)[attr]
        }
      })()

      dialogHeaderEl.onmousedown = (e) => {
        // 鼠标按下，计算当前元素距离可视区的距离
        const disX = e.clientX - dialogHeaderEl.offsetLeft
        const disY = e.clientY - dialogHeaderEl.offsetTop

        const dragDomWidth = dragDom.offsetWidth
        const dragDomHeight = dragDom.offsetHeight

        const screenWidth = document.body.clientWidth
        const screenHeight = document.body.clientHeight

        const minDragDomLeft = dragDom.offsetLeft
        const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth

        const minDragDomTop = dragDom.offsetTop
        const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomHeight

        // 获取到的值带px 正则匹配替换
        let styL = getStyle(dragDom, 'left')
        let styT = getStyle(dragDom, 'top')

        if (styL.includes('%')) {
          styL = +document.body.clientWidth * (+styL.replace(/%/g, '') / 100)
          styT = +document.body.clientHeight * (+styT.replace(/%/g, '') / 100)
        } else {
          styL = +styL.replace(/\px/g, '')
          styT = +styT.replace(/\px/g, '')
        }

        document.onmousemove = function (e) {
          // 通过事件委托，计算移动的距离
          let left = e.clientX - disX
          let top = e.clientY - disY

          // 边界处理
          if (-(left) > minDragDomLeft) {
            left = -minDragDomLeft
          } else if (left > maxDragDomLeft) {
            left = maxDragDomLeft
          }

          if (-(top) > minDragDomTop) {
            top = -minDragDomTop
          } else if (top > maxDragDomTop) {
            top = maxDragDomTop
          }

          // 移动当前元素
          dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`

          // emit onDrag event
          // vnode.child.$emit('dragDialog')
        }

        document.onmouseup = function (e) {
          document.onmousemove = null
          document.onmouseup = null
        }
      }
    }
  }
}
</script>

<style scoped>
.modal-wraper {
  -webkit-app-region: no-drag;
}

.modal-mask {
  position: fixed;
  top: 60px;
  left: 0;
  z-index: 90;
  width: 100%;
  height: calc(100% - 60px);
  background: rgba(0, 0, 0, 0.5);
}

.modal {
  position: fixed;
  left: 50%;
  top: 50%;
  background: #fff;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.1);
  border: 1px solid #ccc;
  z-index: 91;
  min-width: 270px;
  min-height: 260px;
  -webkit-app-region: no-drag;
}

.title {
  height: 40px;
  line-height: 40px;
  background: #eee;
  text-indent: 10px;
  cursor: grabbing;
}

.close {
  position: absolute;
  right: 0;
  top: 0;
  width: 40px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  font-size: 24px;
  color: #555;
  font-weight: 300;
}

.close:hover svg path {
  fill: #f58d16;
}

.content {
  padding: 15px;
  height: calc(100% - 40px);
}
</style>
